import { CoordinatorService } from './coordinator.service';
import { RESULT_LIST_SUBSET } from './result-list$';
import { STG, Stage } from './stage';

export class ResultListSubset {
    private _idSet: Set<string>;
    private _isNot: boolean;
    private _stage: STG;
    private _prefix: string;
    private _title: string;
    private _icon: string;
    private _hasCounter: boolean;
    private _class: string;
    private _back?: () => void;

    constructor(
        private coords: CoordinatorService,
        {
            idSet,
            isNot = false,
            stage,
            prefix,
            title,
            icon,
            hasCounter,
            class: className,
            back,
        }: RESULT_LIST_SUBSET,
    ) {
        this._idSet = new Set(idSet);
        this._isNot = isNot;
        this._stage = stage;
        this._prefix = prefix || '';
        this._title = title;
        this._icon = icon || 'selection';
        this._hasCounter = hasCounter || false;
        this._class = className || '';
        this._back = back;
    }

    get title() {
        return this._title;
    }

    get prefix() {
        return this._prefix;
    }

    get icon() {
        return this._icon;
    }

    get cls() {
        return this._class;
    }

    get stage() {
        return this._stage;
    }

    get back() {
        return this._back;
    }

    get isNot() {
        return this._isNot;
    }

    get idSet() {
        return this._idSet;
    }

    update(params: Partial<RESULT_LIST_SUBSET>) {
        if (params.isNot !== undefined) this._isNot = params.isNot;
    }
}
